export const FIELD_MODE = {
  view: "view",
  edit: "edit",
  viewDisable: "viewDisable",
};
